import { call, put, takeLatest, select } from "redux-saga/effects";
import { getServices } from "api/services/getServices";
import * as types from "redux/reducers/service/actionTypes";
import { QueryServiceProps, LIMIT, SKIP, SORT, addFilter, removeFilter } from "common/";

export const getQueryValidateServices = (state) => state.service.queryDataValidateServices;
export const getCurrentValidateServices = (state) => state.service.validateServices;
export const getLoadingMore = (state) => state.service.loadingMore;

const commonQuery = {
  sort: SORT,
  direction: 'asc',
  filter: "isUpdatedOverOneYear, hasDraft",
  limit: LIMIT,
  skip: SKIP,
  isUpdatedOverOneYear: true,
  hasDraft: false,
};

function* getListValidateServices(action) {
  try {
    const { noLoading, params } = action;

    if (!noLoading) {
      yield put({ type: types.SET_LOADING, loading: true });
    }
    let _query = { ...commonQuery } as QueryServiceProps;
    if (params) {
      _query = { ..._query, ...params };
    }

    if (_query.sort === "nearestToMe") {
      const currentLocation = typeof sessionStorage !== "undefined"
        ? sessionStorage.getItem("@shelter_current_location")
        : null;
      if (currentLocation && currentLocation !== "undefined") {
        try {
          const { longitude, latitude } = JSON.parse(currentLocation);
          const coord = `${longitude}|${latitude}`;
          _query = addFilter(_query, "nearCoordinate", coord);
          _query = addFilter(_query, "currentCoordinate", coord);
        } catch (_) {}
      } else {
        _query = removeFilter(_query, "nearCoordinate");
        _query = removeFilter(_query, "currentCoordinate");
      }
    }

    let services = yield call(getServices, _query);

    if (services.length === LIMIT) {
      yield put({ type: types.SET_CAN_LOADING_MORE, canLoadmore: true });
    } else if (services.length < LIMIT) {
      yield put({ type: types.SET_CAN_LOADING_MORE, canLoadmore: false });
    }

    yield put({ type: types.SET_QUERY_VALIDATE_SERVICES, queryDataValidateServices: _query });
    yield put({ type: types.UPDATE_LIST_VALIDATE_SERVICES, services });
    yield put({ type: types.SET_LOADING, loading: false });
  } catch (error) {
    return Promise.reject(error);
  }
}

function* loadmoreValidateServices(action) {
  try {
    yield put({ type: types.SET_LOADING_MORE, loadingMore: true });
    let _query: QueryServiceProps;

    _query = yield select(getQueryValidateServices);
    _query = {
      ..._query,
      skip: _query.skip + _query.limit,
    };

    let services = yield call(getServices, _query);

    if (services.length === LIMIT) {
      yield put({ type: types.SET_CAN_LOADING_MORE, canLoadmore: true });
    } else if (services.length < LIMIT) {
      yield put({ type: types.SET_CAN_LOADING_MORE, canLoadmore: false });
    }

    const currentServices = yield select(getCurrentValidateServices);

    yield put({ type: types.SET_QUERY_VALIDATE_SERVICES, queryDataValidateServices: _query });
    yield put({ type: types.UPDATE_LIST_VALIDATE_SERVICES, services: [...currentServices, ...services] });
    yield put({ type: types.SET_LOADING_MORE, loadingMore: false });
  } catch (error) {
    return Promise.reject(error);
  }
}

function* ValidateService() {
  yield takeLatest(types.GET_VALIDATE_SERVICES_REQUEST, getListValidateServices);
  yield takeLatest(types.LOAD_MORE_VALIDATE_SERVICES_REQUEST, loadmoreValidateServices);
}

export default ValidateService;
